$(document).ready(function () {
    $(this).parent('.m-product-item').find('.merox-1').show();
    $(this).parent('.m-product-item').find('.merox-2').hide();
    $(".mero_thumbnail_image img").click(function () {
      var value = $(this).attr("src");
      // console.log("dsafdfs" + value)
      $('img#inner-popup-content-left').attr("src", value);
    });
    // Bulk add to cart ajax function start
    function bulkATC() {
      $('input.m_atc:checkbox:checked').each(function () {
        // console.log("index_at: " + index_at);
        var qty = 1;
        var id = $(this).attr('data-varid');
        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          async: false,
          data: {
            quantity: qty,
            id: id
          },
          success: function () {
          }
        });
        // index_at++;
      });
      window.location.href = '/cart';
    }// Bulk add to cart ajax function end

    // ATC onlick event Code start
    $('.bundles-atc').click(function () {
      $('.bundles-atc').text("");
      $('.bundles-atc').addClass("m-loader");
      setTimeout(bulkATC, 100);
    });// ATC onlick event Code end
      function update_cart(){
          var $header_items_count = $('.header_items_count');
          var $header_items_total_price = $('.header_items_total_price');
          var $header_atcbtn = $(".header_atcbtn");
          var $bundles_atc = $(".bundles-atc");
          var checkedCheckboxes = $('input.m_atc:checkbox').filter(':checked');
          var countCheckedCheckbox = checkedCheckboxes.length;
          $header_items_count.text(countCheckedCheckbox);

          if (countCheckedCheckbox >= 1) {
            var total = 0;
            checkedCheckboxes.each(function () {
              var productprice = $(this).attr('data-price');
              productprice = (+productprice);
              total += productprice;
            });
            var newtotal = (Math.round(total * 100) / 100).toFixed(2);
            $header_items_total_price.text(newtotal);
            $header_atcbtn.removeClass("m_disabled");
            $bundles_atc.removeAttr("disabled");
          } else {
            $header_atcbtn.addClass("m_disabled");
            $bundles_atc.attr("disabled", "disabled");
            $header_items_total_price.text('0');
          }
        }
    $("input:checkbox").change(function () {
    update_cart();
    });


// popup data after click Preview
    $('.product-info-btn').click(function (e) {
      $('#m-select-box, .add_to_list').show();  
      $(this).parents(".m-product-item").find('input').addClass("m_opened");
      var fimg = $(this).attr('data-fimg').split('|');
      var data_var_title = $(this).attr('data-variants-title').split('|');
      // console.log(data_var_title);
      $('#m-select-box').empty();
    // add the first option that doesn't belong to the var_options array
      $('#m-select-box').append($('<option>', {
            value: "Select Variant",
            text: "Select Variant",
            selected: true,
            disabled: true
      }));
      // Dropdown list apend to popup
      if(data_var_title.length > 1){
      for (var i = 0; i < data_var_title.length; i++) {
        var optTitle = data_var_title[i];
        $('#m-select-box').append($('<option>', {
            value: optTitle.split('#')[1],
            text: optTitle.split('#')[0],
            data_variant_price: optTitle.split('#')[2],
            disabled: Boolean(optTitle.split('#')[3])
        }));
      }
}else{
      $('#m-select-box, .add_to_list').hide();  
}
      // Show the product info popup
      $('#productinfopopup_wrapper').show();

      // Set the src of the main image to the first element in the fimg array
      $('#inner-popup-content-left').attr("src", fimg[0]);

      // Loop through the thumbnail images and set their src to the corresponding element in the fimg array
      $('.mero_thumbnail_image img').each(function (i) {
        if (i < fimg.length) {
          $(this).attr("src", fimg[i]).show();
        } else {
          $(this).hide();
        }
      });

      // Set the text of the title, price, and sku elements to the corresponding data attributes
      $('#prodTitle').text($(this).attr('data-title'));
      var content = $(this).parent('.m-product-item').find('.popup_desc_data').html();
      $('#prodDescription').html(content);
      var ppUrl = $(this).attr('data-url');
      $('#prodURL').attr("href", `${ppUrl}`);
      $('#price').text($(this).attr('data-price'));
      $('#sku').text($(this).attr('data-sku'));
    });


<!-- Close modal code start-->
    $('#m-close, #m-btn-id').click(function () {
      $('.m_atc').removeClass('m_opened');
      $('#productinfopopup_wrapper').hide();
    });
    $('#productinfopopup').click(function (event) {
      if (event.target == productinfopopup) {
      $('.m_atc').removeClass('m_opened');
        $('#productinfopopup_wrapper').hide();
      }
    });
<!-- Close modal code end-->

    $("#readmore").click(function () {
      var description = $('#prodDescription');
      if ($('#readmore').text() == "Read more...") {
        description.css('max-height', 'max-content');
        $(this).text("Read less")
      } else {
        description.css('max-height', '80px');
        $(this).text("Read more...")
      }
    });
    // redirect to new tab modal show product button  
    $('#prodURL').click(function (e) {
      e.preventDefault();
      var prodURL = $(this).attr("href");
      window.open(prodURL, '_blank');
    });

  $('#m-select-box').change(function() {
    var selectedValue = $(this).val();
    var selectedOptionText = $("#m-select-box option:selected").text();
    var selectedVariantPrice = $("#m-select-box option:selected").attr("data_variant_price");
    
    // console.log(selectedOptionText);
    // console.log(selectedVariantPrice);
    $('.m_opened').attr("data-varid",selectedValue);
    $('.m_opened').parents('.m-product-item').find('.m-slash').show();
    $('.m_opened').siblings('.m_show_popup').find('.mpp_product_variant_sku').text(selectedOptionText);
    $('.m_opened').attr("data-price",selectedVariantPrice);
    
    $('.m_opened').prop("checked", true);
    $('.m_opened').show();
    $('.m_opened').parent('.m-product-item').removeClass('m-relative');
    update_cart();
    
  if ($('.m_opened').is(":checked")) {
    $('.m_opened').parent('.m-product-item').find('.merox-1').hide();
    $('.m_opened').parent('.m-product-item').find('.merox-2').show();
    $('.m_opened').parent('.m-product-item').removeClass('m-relative');
    $('.m_opened').parent('.m-product-item').find('.product-info-btn').removeClass('product-info-btn-2');
  } else {
    $('.m_opened').parent('.m-product-item').find('.merox-1').show();
    $('.m_opened').parent('.m-product-item').find('.merox-2').hide();
    $('.m_opened').parent('.m-product-item').find('.product-info-btn').addClass('product-info-btn-2');
    
  }
});

$("input:checkbox").change(function () {
  if ($(this).is(":checked")) {
    $(this).parent('.m-product-item').find('.merox-1').hide();
    $(this).parent('.m-product-item').find('.merox-2').show();
    $(this).parent('.m-product-item').find('.product-info-btn').removeClass('product-info-btn-2');
  } else {
    $(this).parents('.m-product-item').find('.m-slash').hide();
    $(this).parent('.m-product-item').find('.merox-1').show();
    $(this).parent('.m-product-item').find('.merox-2').hide();
    $(this).parent('.m-product-item').addClass('m-relative');
    $(this).parent('.m-product-item').find('.product-info-btn').addClass('product-info-btn-2');
    $(this).parent('.m-product-item').find('.mpp_product_variant_sku').text('');
  }
});
    // slick slider code start here
    $('.scrollable_bar').slick({
      dots: false,
      infinite: false,
      speed: 500,
      slidesToShow: 4,
      slidesToScroll: 1,
      arrows: true,
      prevArrow: '.slick-prev',
      nextArrow: '.slick-next',
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        }
      ]
    });  // slick slider code end here

    // fancybox code start here
    $("[data-fancybox]").fancybox({
      buttons: [
        'slideShow',
        'share',
        'zoom',
        'fullScreen',
        'close'
      ],
      loop: true
    });  // fancybox code end here
});// document.ready close